<template>
  <div id="app" class="min-h-screen">
    <Menu />
    <clean-gateway-modal />
  </div>
</template>

<script>
import Menu from "./components/shared/Menu.vue";
import CleanGatewayModal from "./components/shared/modals/clean-gateway-modal.vue";

export default {
  components: {Menu, CleanGatewayModal},
  
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {},
};
</script>